interface ReactMethods {
  moveSelectionUp: CallableFunction;
  moveSelectionDown: CallableFunction;
  setResults: CallableFunction;
  getCommands: CallableFunction;
  // eslint-disable-next-line no-unused-vars
  setShow: (value: boolean) => void;
  // eslint-disable-next-line no-unused-vars
  setPos: (x: number, y: number) => void;
  getSelectedCommand: () => { name: string, callback: CallableFunction };
}

class CommandAdapter {
  public moveSelectionUp: CallableFunction = () => null;

  public moveSelectionDown: CallableFunction = () => null;

  public setResults: CallableFunction = () => null;

  public setShow: CallableFunction = () => null;

  public setPos: CallableFunction = () => null;

  public getSelectedCommand: () => {
      name: string,
      callback: CallableFunction,
      useTransactionLogic?: boolean,
    } =
    () => ({ name: 'noop', callback: () => null });

  public getCommands: CallableFunction = () => null;

  set reactMethods({
    moveSelectionUp,
    moveSelectionDown,
    setResults,
    setShow,
    setPos,
    getSelectedCommand,
    getCommands,
  }: ReactMethods) {
    this.moveSelectionUp = moveSelectionUp;
    this.moveSelectionDown = moveSelectionDown;
    this.setResults = setResults;
    this.setShow = setShow;
    this.setPos = setPos;
    this.getSelectedCommand = getSelectedCommand;
    this.getCommands = getCommands;
  }
}

export default new CommandAdapter();
